import LogoSmall from "../components/Logo/LogoSmall";
import SubmitButton from "../components/buttons/SubmitButton";

const HomeAnom = ({ onClickLogin, onSignupClick }) => {

  return (
    <div className="min-h-screen bg-white">
      <header className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
        <LogoSmall />
      </header>

      <section>
        <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="mr-auto place-self-center lg:col-span-7">
            <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl">
              Sponsored Content made simple
            </h1>
            <p className="max-w-2xl mb-6 text-gray-500 lg:mb-8 md:text-lg lg:text-xl">
              No more back and forth on email between advertisers and
              publishers. Scale your native advertising for high performance
              on premium publishers with Contimo.
            </p>
            <div>
              <div className="float-left">
                <SubmitButton submitText={"Sign in"} onClick={onClickLogin} />
              </div>
              <div className="float-right">
                <SubmitButton submitText={"Get Started"} onClick={onSignupClick} />
              </div>
            </div>
          </div>
          <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
            <img
              src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/phone-mockup.png"
              alt="mockup"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
export default HomeAnom;
